
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import store from './store/index'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react';
import '@progress/kendo-theme-default/dist/all.css';
import { persister } from './store'
import { getConfig } from './authentication/auth0/config';
import { Auth0Provider } from '@auth0/auth0-react';

const config = getConfig();

const providerConfig = {
  domain: config.domain,
  clientId: config.clientId,
  authorizationParams: {
    redirect_uri: process.env.REACT_APP_REDIRECT_URI,
    ...(config.audience ? { audience: config.audience } : null)
  },
};
document.title = `${process.env.REACT_APP_CLIENT_NAME || 'DefaultClientName'} | Admin`
const faviconLink = document.createElement('link')
faviconLink.rel = 'icon'
faviconLink.type = 'image/x-icon'
faviconLink.href = process.env.REACT_APP_LOGO_URL_LIGHT || './default-favicon.ico'
document.head.appendChild(faviconLink)
createRoot(document.getElementById('root')).render(
  <Auth0Provider {...providerConfig}><Provider store={store}>

    <PersistGate persistor={persister} loading={null}>
      <App />
    </PersistGate>
  </Provider></Auth0Provider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
